import React from 'react';
import './styles.css';
import { useHistory } from 'react-router';
import { Row, Col } from 'antd';
import {
  AdvanceTable,
  AdvanceStatusText,
  BupSpinner,
  ButtonBackData,
  DividerContainer,
  ErrorMessage,
  PageLayout,
  RequestClosureModal,
} from '@BUP/components';
import { useBraveUpSurveysApi, useQuestionProApi } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

const DataAdvanceStatusPage = () => {
  const history = useHistory();
  const [t] = useTranslation();
  const { survey, isLoadingSurvey, errorSurvey } = useBraveUpSurveysApi();
  const { isLoadingFolders, errorFolders } = useQuestionProApi(survey);
  // console.log(survey, folders);
  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title={t('pages.data.advanceStatus.dividerTitle')} />
      {isLoadingSurvey || isLoadingFolders ? (
        <BupSpinner size="large" />
      ) : errorSurvey || errorFolders ? (
        <ErrorMessage />
      ) : (
        <>
          <AdvanceStatusText />
          <AdvanceTable />
          <Row className="advanceStatus_row-button">
            <Col span={24} align="end">
              <RequestClosureModal />
            </Col>
          </Row>
        </>
      )}
    </PageLayout>
  );
};

export default DataAdvanceStatusPage;
